const combineValidators = (validators, shouldStopAfterFirstFail = false) => value => {
  const errors = {}
  for (let index = 0; index < validators.length; index++) {
    const validator = validators[index]
    const singleResponse = validator(value)
    if (singleResponse) {
      errors.isValid = false
      errors.message = errors.message ? [...errors.message, singleResponse.message] : [singleResponse.message]
      if (shouldStopAfterFirstFail) {
        break
      }
    }
  }
  if (Object.keys(errors).length) {
    return errors
  }
}

export default combineValidators
